export default __webpack_public_path__ + "static/media/whatsapp.8121c314.svg";